import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { loadingBarReducer } from 'react-redux-loading-bar';

import status from './status';
import customer from './customer';
import auth from './auth';
import notification from './notification';
import textoverlay from './textoverlay';
import section from './section';
import next from './next';
import content from './content';
import upload from './upload';
import payever from './payever';
import serialhelpoverlay from './serialhelpoverlay';
// import imageoverlay from './imageoverlay';

export default combineReducers({
	status,
	customer,
	auth,
	notification,
	textoverlay,
	section,
	next,
	content,
	upload,
	payever,
	serialhelpoverlay,
	routing: routerReducer,
	loadingBar: loadingBarReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js